import React from 'react';
import WorkMultipleEdit from './WorkMultipleEdit';

const WorkResultBatchEdit = props => (
  <WorkMultipleEdit isWorkSchedule={false} {...props} />
);

export default WorkResultBatchEdit;



// WEBPACK FOOTER //
// ./src/pages/WorkResultMultipleEdit.jsx